const SEO = [
	{
		page: "home",
		description:
			"I am a full-stack JavaScript developer (MERN) and software engineer with expertise in ReactJS. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Rowan", "Rowan Q", "Rowan Quinn"],
	},

	{
		page: "about",
		description:
			"I am a full-stack JavaScript developer (MERN) and software engineer with expertise in ReactJS. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Rowan", "Rowan Q", "Rowan Quinn"],
	},

	{
		page: "projects",
		description:
			"I have worked on a variety of projects over the years, and I am proud of the progress I've made.",
		keywords: ["Rowan", "Rowan Q", "Rowan Quinn"],
	},

	{
		page: "contact",
		description:
			"If you want to reach out, I am always open to new ideas and opportunities. :)",
		keywords: ["Rowan", "Rowan Q", "Rowan Quinn"],
	},
];

export default SEO;
